<template>
  <div class="aBottom">
    <div class="bottomLeft">
      <div class="topTitle">检测记录</div>
      <div class="aTitle">
        <div class="itemLabel hasColor" v-for="i in titles">{{i}}</div>
      </div>
      <div class="aContent">
        <div
          v-for="(item,index) in bottomData"
          v-bind:class="index%2 == 1 ? 'hasColor' : 'transparent' "
          class="item"
        >
          <div class="itemLabel" v-for="i in item">{{i}}</div>
        </div>
      </div>
    </div>
    <div class="bottomRight">
      <div class="right" id="checkrightCView">
        <div  class="rightItem">
          <div class="rightTitle" >生成报告数量</div>
          <div class="imgBar" id="img0">
            <div class="percentView">
              <div class="pValueLabel">{{orgReportCount}}</div>
              <div class="pUnitLabel">份</div>
            </div>
          </div>
        </div>

        <div class="rightItem">
          <div class="rightTitle">查看报告人数</div>
          <div class="imgBar" id="img1">
            <div class="percentView">
              <div class="pValueLabel">{{orgReportLookCount}}</div>
              <div class="pUnitLabel">份</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
export default {
  name: "ABigScreemBottom",
  props: ["bottomData", "orgReportCount", "orgReportLookCount"],
  components: {
    RadialProgressBar
  },
  computed: {
    percent0: function() {
      var p = (parseFloat(this.percent_blood_pressure) * 100).toFixed(0);
      if (isNaN) {
        return parseInt(p);
      } else {
        return 0;
      }
    },
    percent1: function() {
      var p = (parseFloat(this.percent_blood_sugar) * 100).toFixed(0);
      if (isNaN) {
        return parseInt(p);
      } else {
        return 0;
      }
    }
  },
  data() {
    return {
      titles: [
        "序号",
        "检查时间",
        "居民",
        "年龄",
        "性别",
        "检测类型",
        "分析结果"
      ],
      startColor: "#feff90FF",
      stopColor: "#feff9024",
      startColor1: "#feff90FF",
      stopColor1: "#feff9024",
      innerStrokeColor: "#002370a1"
    };
  }
};
</script>

<style scoped>
.aBottom {
  height: 320px;
  padding: 34px 42px;
  display: flex;
  flex-direction: row;
}

.bottomLeft {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1.7;
}

.bottomRight {
  flex: 0.7;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.topTitle {
  color: #c7e8ffff;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 15px;
}

.aTitle {
  width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
}

.aContent {
  width: 100%;
  overflow-y: scroll;
  flex: 1;
}

.aContent::-webkit-scrollbar {
  display: none;
}

.item {
  width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
}

.itemLabel {
  height: 100%;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  color: #c6e8ff;
  flex: 1;
  opacity: 1;
}

.hasColor {
  background: rgba(110, 130, 255, 0.2);
}

.transparent {
  background: transparent;
}

#checkrightCView {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.right > div {
  height: 250px;
  display: flex;
  flex-direction: column;
}

.right {
  padding-left: 50px;
}

.rightTitle {
  color: #c7e8ffff;
  font-size: 16px;
  padding-bottom: 25px;
}

.imgBar {
  flex: 1;
  height: 207px;
  width: 207px;
}

#img0 {
  background-image: url("~@/assets/images/bigScreem/pbar0.png");
}

#img1 {
  background-image: url("~@/assets/images/bigScreem/pbar1.png");
}

.percentView {
  height: 100%;
  display: flex;
  color: #c7e8ff;
  font-size: 44px;
  align-items: baseline;
  justify-content: center;
}

.pValueLabel {
  height: 207px;
  line-height: 207px;
}

.pUnitLabel {
  font-size: 14px;
}
</style>
